import { Map as ImmutableMap, fromJS } from 'immutable';
import ConditionalFormattingColorSelect from '../ConditionalFormattingColorSelect';
import { EVENTS } from '../../../lib/events';
import { jsx as _jsx } from "react/jsx-runtime";
const ConfigConditionalFormattingColorPalette = ({
  report,
  onChange,
  selectedColumnName,
  tracker
}) => {
  var _report$getIn;
  const existingConditionalFormatting = (_report$getIn = report.getIn(['displayParams', 'columns', selectedColumnName, 'format', 'conditionalFormatting'], ImmutableMap())) === null || _report$getIn === void 0 ? void 0 : _report$getIn.toJS();
  const selectedPalette = existingConditionalFormatting === null || existingConditionalFormatting === void 0 ? void 0 : existingConditionalFormatting.palette;
  const updateColorPalette = palette => {
    const conditionalFormatting = Object.assign({}, existingConditionalFormatting, {
      palette
    });
    tracker === null || tracker === void 0 || tracker.track(EVENTS.conditionalFormattingInteraction, {
      actionType: 'updateColorPalette',
      color: palette
    });
    return report.setIn(['displayParams', 'columns', selectedColumnName, 'format', 'conditionalFormatting'], fromJS(conditionalFormatting));
  };
  const handleChange = palette => {
    const nextReport = updateColorPalette(palette);
    onChange(nextReport);
  };
  return /*#__PURE__*/_jsx(ConditionalFormattingColorSelect, {
    onChange: handleChange,
    selectedPalette: selectedPalette
  });
};
export default ConfigConditionalFormattingColorPalette;